import React, { useEffect, useMemo, useRef, useState } from "react";
import { Star } from "../../assets/icons/Star";
import { Heart } from "../../assets/icons/Heart";

import { Send } from "../../assets/icons/Send";
import { MovieMode } from "../../assets/icons/MovieMode";
import MusicIcon from "../../assets/icons/MusicIcon";
import DisabledMusin from "../../assets/icons/DisabledMusin";
import { Speaker } from "../../assets/icons/Speaker";
import { LiveStatus } from "../../assets/icons/LiveStatus";
import { Seed } from "../../assets/icons/Seed";
import "./footer.css";
import CustomToolTip from "../CustomToolTip/CustomToolTip";
import { Help } from "../../assets/icons/Help";
import HelpModal from "./components/HelpModal";
import LiveStatusModal from "./components/LiveStatus/LiveStatusModal";
import useCounterStore from "../../store/store";
import sound_bg from "../../assets/sounds/sound_bg.mp3";

import DisableSpeaker from "../../assets/icons/DisableSpeaker";

const Footer = () => {
  // const isStar = true; // Replace with actual state or prop
  // const isLiked = true; // Replace with actual state or prop

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openStatsModal, setOpenStatsModal] = useState<boolean>(false);

  const [isStar, setIsStar] = useState<boolean>(false);
  const [isLiked, setIsLiked] = useState<boolean>(false);

  // const {
  //   soundAction,
  //   setMovieMode,
  //   turboAction,
  //   setIsStar,
  //   setIsLiked,
  //   setIsMusic,
  //   isTurbo,
  //   isSound,
  //   isMovieMode,
  //   isStar,
  //   isLiked,
  //   isMusic,
  // } = useCounterStore((state) => state);

  const {
    isMovieMode,
    isSound,
    isMusic,
    setMovieMode,
    setIsMusic,
    soundAction,
  } = useCounterStore((state) => state);

  const backgroundMusicRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    backgroundMusicRef.current = new Audio(sound_bg);
  }, []);

  useEffect(() => {
    const music = backgroundMusicRef.current;
    if (music) {
      if (isMusic) {
        music.play();
      } else {
        music.pause();
      }
    }
  }, [isMusic]);

  const rateLikeData = useMemo(
    () => [
      {
        icon: Star,
        titile: "1603",
        toolTip: "Favorite",
        fill: isStar ? "#ff9820" : "#b3bec1",
        key: "favorite",
      },
      {
        icon: Heart,
        titile: "1603",
        toolTip: "Like",
        fill: isLiked ? "#fc3c3c" : "#b3bec1",
        key: "like",
      },
      {
        icon: Send,
        titile: "",
        toolTip: "Share",
        fill: "",
        key: "Share",
      },
    ],
    // []
    [isStar, isLiked]
  );

  const otherOptions = useMemo(
    () => [
      {
        key: "movie_mode",
        icon: MovieMode,
        toolTip: "Movie Mode",
        fill: isMovieMode ? "#7717ff" : "#b3bec1",
        titile: "",
      },
      {
        key: "background_sound",
        icon: isMusic ? MusicIcon : DisabledMusin,
        toolTip: "Background Sound",
        fill: isMusic ? "#7717ff" : "#b3bec1",
        titile: "",
      },
      {
        key: "sound",
        icon: isSound ? Speaker : DisableSpeaker,
        fill: isSound ? "#7717ff" : "#b3bec1",
        toolTip: "Sound",
        titile: "",
      },
      {
        key: "live_status",
        icon: LiveStatus,
        toolTip: "Live Stats",
        fill: "#b3bec1",
      },
      {
        key: "seed",
        icon: Seed,
        toolTip: "Seed",
        fill: "#b3bec1",
        titile: "",
      },
      {
        key: "help",
        icon: Help,
        toolTip: "Help",
        fill: "#b3bec1",
        titile: "",
      },
    ],
    [isMovieMode, isMusic, isSound]
    // []
  );

  const combineArray = useMemo(
    () => [...rateLikeData, ...otherOptions],
    [rateLikeData, otherOptions]
  );

  const handleIconsAction = (key: string) => {
     switch (key) {
      case "sound":
        soundAction();
        break;

      case "movie_mode":
        setMovieMode();
        break;

      case "help":
        setOpenModal(true);
        break;

      case "turbo":
        // turboAction();
        break;

      case "live_status":
        setOpenStatsModal(!openStatsModal);
        break;

      case "favorite":
        setIsStar(!isStar);
        // setIsStar(!isStar);
        break;

      case "like":
        setIsLiked(!isLiked);
        // setIsLiked();
        break;

      case "background_sound":
        setIsMusic();

        break;

      default:
        break;
    }
  };

  return (
    <div className="footerContainer">
      {/* Desktop View */}
      {/* <div
          className={`${
            isMovieMode ? "max-w-full" : "max-w-[1200px]"
          }   w-full m-auto  justify-between items-center flex-row gap-2 xs:hidden md2:flex`}
        > */}

      <div className={`footerContainer_Inner`}>
        <div className="favLikeContainerOuter">
          {rateLikeData?.map((item, ind) => {
            const Icon = item?.icon;
            return (
              <div
                key={ind}
                className="favLikeContainerInner"
                onClick={() => handleIconsAction(item?.key)}
              >
                <CustomToolTip
                  title={item?.toolTip}
                  isArrow={true}
                  placement="top"
                  children={
                    <div className="favIcon">
                      <Icon fill={item.fill} width="24" height={"24"} />
                    </div>
                  }
                />
                {item?.key == "favorite" ? (
                  <span
                    className="favIconText"
                    style={{ color: `${isStar ? "#ff9820" : "#b3bec1"}` }}
                  >
                    {" "}
                    {item?.titile}{" "}
                  </span>
                ) : item?.key == "like" ? (
                  <span
                    className="favIconText"
                    style={{ color: `${isLiked ? "#fc3c3c" : "#b3bec1"}` }}
                  >
                    {item?.titile}
                  </span>
                ) : (
                  <span
                    className={`text-[14px] font-bold ml-[5px] text-lightGray} xs:hidden md2:block`}
                  >
                    {item?.titile}
                  </span>
                )}
              </div>
            );
          })}
        </div>
        <div className="otherOptionsOuter">
          {otherOptions?.map((item, ind) => {
            const Icon = item?.icon;

            return (
              // <div
              //   key={ind}
              //   className={`flex justify-start ml-[15px] mr-[15px] last:mr-0 ${
              //     item.key === "movie_mode" || item.key === "hotkey"
              //       ? "hidden md2:block"
              //       : ""
              //   }`}
              // >
              <div key={ind} className={`optionIconContainer`}>
                <CustomToolTip
                  title={item?.toolTip}
                  isArrow={true}
                  placement="top"
                  children={
                    <div
                      className={`cursor-pointer fontSemiBold font-bold xs:w-[19px] md:w-[24px] `}
                      onClick={() => handleIconsAction(item?.key)}
                    >
                      <div className="cursor-pointer xs:w-[19px] md:w-[24px]">
                        <Icon fill={item.fill} width="24" height={"24"} />
                      </div>
                    </div>
                  }
                />
              </div>
            );
          })}
        </div>
      </div>


      {/* Mobile and Tabs */}
      
        <div className="mobileScreen otherOptionsOuter">
          {/* <div className="flex justify-between items-center w-full "> */}
            {combineArray?.map((item, ind) => {
              const Icon = item?.icon;
              return (
           <div
                key={ind}
                className=" "
                // onClick={() => handleIconsAction(item?.key)}
              >
                    {/* <div key={ind} className={`optionIconContainer`}> */}
                <CustomToolTip
                  title={item?.toolTip}
                  isArrow={true}
                  placement="top"
                  children={
                    <div
                      className={`cursor-pointer fontSemiBold font-bold  `}
                      onClick={() => handleIconsAction(item?.key)}
                    >
                      <div className="cursor-pointer xs:w-[19px] md:w-[24px]">
                        <Icon fill={item.fill} width="24" height={"24"} />
                      </div>
                    </div>
                  }
                />
              {/* </div> */}
              </div>
              );
            })}
          {/* </div> */}
        </div>

      <HelpModal openModal={openModal} setOpenModal={setOpenModal} />

      {/* Live Status */}
      {openStatsModal && <LiveStatusModal setOpenModal={setOpenStatsModal} />}
    </div>
  );
};

export default Footer;
